import type * as Types from '../../../graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SearchContigQueryVariables = Types.Exact<{
  searchTerm: Types.InputMaybe<Types.Scalars['String']['input']>;
  genomeId: Types.InputMaybe<Types.Scalars['Long']['input']>;
  limit: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type SearchContigQuery = { search: { contigSearch: { limit: number | null, searchTerm: string | null, contigs: Array<{ id: number, accession: string, name: string | null, length: number, sequenceType: string, organism: { id: number, name: string | null } }> } } };

export type GetContigQueryVariables = Types.Exact<{
  contigId: Types.Scalars['Long']['input'];
}>;


export type GetContigQuery = { contig: { id: number, accession: string, name: string | null, length: number, sequenceType: string, organism: { id: number, name: string | null } } | null };

export type ContigInfoFragment = { id: number, accession: string, name: string | null, length: number, sequenceType: string, organism: { id: number, name: string | null } };

export const ContigInfoFragmentDoc = gql`
    fragment ContigInfo on Contig {
  id
  accession
  name
  length
  sequenceType
  organism {
    id
    name
  }
}
    `;
export const SearchContigDocument = gql`
    query searchContig($searchTerm: String, $genomeId: Long, $limit: Int) {
  search {
    contigSearch(searchTerm: $searchTerm, genomeId: $genomeId, limit: $limit) {
      limit
      searchTerm
      contigs {
        ...ContigInfo
      }
    }
  }
}
    ${ContigInfoFragmentDoc}`;

/**
 * __useSearchContigQuery__
 *
 * To run a query within a React component, call `useSearchContigQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchContigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchContigQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      genomeId: // value for 'genomeId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchContigQuery(baseOptions?: Apollo.QueryHookOptions<SearchContigQuery, SearchContigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchContigQuery, SearchContigQueryVariables>(SearchContigDocument, options);
      }
export function useSearchContigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchContigQuery, SearchContigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchContigQuery, SearchContigQueryVariables>(SearchContigDocument, options);
        }
export function useSearchContigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchContigQuery, SearchContigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchContigQuery, SearchContigQueryVariables>(SearchContigDocument, options);
        }
export type SearchContigQueryHookResult = ReturnType<typeof useSearchContigQuery>;
export type SearchContigLazyQueryHookResult = ReturnType<typeof useSearchContigLazyQuery>;
export type SearchContigSuspenseQueryHookResult = ReturnType<typeof useSearchContigSuspenseQuery>;
export type SearchContigQueryResult = Apollo.QueryResult<SearchContigQuery, SearchContigQueryVariables>;
export const GetContigDocument = gql`
    query getContig($contigId: Long!) {
  contig(contigId: $contigId) {
    ...ContigInfo
  }
}
    ${ContigInfoFragmentDoc}`;

/**
 * __useGetContigQuery__
 *
 * To run a query within a React component, call `useGetContigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContigQuery({
 *   variables: {
 *      contigId: // value for 'contigId'
 *   },
 * });
 */
export function useGetContigQuery(baseOptions: Apollo.QueryHookOptions<GetContigQuery, GetContigQueryVariables> & ({ variables: GetContigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContigQuery, GetContigQueryVariables>(GetContigDocument, options);
      }
export function useGetContigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContigQuery, GetContigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContigQuery, GetContigQueryVariables>(GetContigDocument, options);
        }
export function useGetContigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContigQuery, GetContigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContigQuery, GetContigQueryVariables>(GetContigDocument, options);
        }
export type GetContigQueryHookResult = ReturnType<typeof useGetContigQuery>;
export type GetContigLazyQueryHookResult = ReturnType<typeof useGetContigLazyQuery>;
export type GetContigSuspenseQueryHookResult = ReturnType<typeof useGetContigSuspenseQuery>;
export type GetContigQueryResult = Apollo.QueryResult<GetContigQuery, GetContigQueryVariables>;